import React from 'react';

import VoucherInput from './VoucherInput';

interface VoucherSectionProps {
  onKeyboardChange?: (open: boolean) => void;
}

const VoucherSection: React.FC<VoucherSectionProps> = ({ onKeyboardChange }) => {
  return <VoucherInput onKeyboardChange={onKeyboardChange} />;
};

export default VoucherSection;
